// @flow
import { girdleDisplayValues } from '@src/utils/displayMaps';
import type { DiamondType } from '@types/diamond';

// The functions in this file are javascript versions of the same methods in diamond.rb, used for formatting diamond
// data for display.

function measureLengthLong(diamond) {
  return parseFloat(diamond.measure_length).toFixed(2);
}

function measureWidthLong(diamond) {
  return parseFloat(diamond.measure_width).toFixed(2);
}

function measureDepthLong(diamond) {
  return parseFloat(diamond.measure_depth).toFixed(2);
}

export function measurementLong(diamond: DiamondType) {
  return [
    measureLengthLong(diamond),
    measureWidthLong(diamond),
    measureDepthLong(diamond)
  ].join('x') + ' mm';
}

export function girdleLong(diamond: DiamondType) {
  if (
    (!diamond.girdle_min || !diamond.girdle_min.length) &&
    (!diamond.girdle_max || !diamond.girdle_max.length)
  ) return '';

  const girdle = diamond.girdle_min === diamond.girdle_max
    ? [diamond.girdle_max]
    : [diamond.girdle_min, diamond.girdle_max];

  return girdle.map((g) => girdleDisplayValues[g]).join(' - ');
}
